import {ChartData} from "components/dashboard/dataset-window/models/types";
import {DatasetLoadingConf, IDataSet} from "components/dashboard/charts/interfaces";
import {addToDate, formatTime, truncateDate} from "utils/time-utils";

export function defaultFromDateTime(props: { loadConf?: DatasetLoadingConf, referenceTime?: string }) {
    const align = props.loadConf?.alignUnit;
    const lag = props.loadConf?.lag ?? 6;
    const lagUnit = props.loadConf?.lagUnit ?? "HOURS";

    const startingDate = props.referenceTime ? new Date(props.referenceTime) : new Date()

    const date = truncateDate(startingDate, align);

    return addToDate(date, -lag, lagUnit);
}

export function defaultToDateTime(props: { loadConf?: DatasetLoadingConf, referenceTime?: string }) {
    const align = props.loadConf?.alignUnit;
    const lead = props.loadConf?.lead ?? 0;
    const leadUnit = props.loadConf?.leadUnit ?? "HOURS";

    const startingDate = props.referenceTime ? new Date(props.referenceTime) : new Date()

    const date = truncateDate(startingDate, align);

    return addToDate(addToDate(date, lead, leadUnit), 1, "MINUTES");
}

export const convertStringDateToDate = (dataArray: Array<any>) => {
    return dataArray.map((d) => {
        return new Date(d["key"]);
    });
};

export const convertValue = (dataArray: Array<any>) => {
    return dataArray?.map((d) => {
        return d["value"];
    });
};

export const convertKey = (dataArray: Array<any>) => {
    return dataArray.map((d) => {
        return new Date(d["key"])
    });
};

export const convertDataToChartsData = (datasetArray: Array<IDataSet>): Array<ChartData> => {
    return datasetArray.map((d) => {
        return {
            id: d.identifier,
            title: d.title.replace(/_/g, " "),
            unit: d.unit,
            keyArr: convertKey(d.data),
            valueArr: convertValue(d.data),
            decimalPlaces: d.decimalPlaces
        };
    });
};

export const isElementInDom = (id: string) => {
    const elementExists = document.getElementById(id);
    return !!elementExists;
};

export const round2decimals = (num: number) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const hexToRgb = (hex: string) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    let colorRGB = null;
    if (result !== null) {
        const r = parseInt(result[1], 16);
        const g = parseInt(result[2], 16);
        const b = parseInt(result[3], 16);
        colorRGB = `rgba(${r},${g},${b},0.7)`;
    }
    return colorRGB ? colorRGB : null;
};

export const getAllDatasetsTimestamps = (datasets: Array<IDataSet>): { content: Array<any>, columns: Array<string> } => {
    const columns = [];
    const tableTemplate: { [key: string]: any } = {};

    for (const dataset of datasets) {
        const columnName = `${dataset.title.replaceAll("_", " ")}${dataset.unit ? `, ${dataset.unit}` : ""}`;
        columns.push(columnName);

        for (const {key, value} of dataset.data) {
            const tempKey = key.slice(0, key.length - 5) + '.000Z';
            tableTemplate[tempKey] = {
                ...tableTemplate[tempKey],
                [columnName]: value ? value.toFixed(dataset.decimalPlaces || 2) : null
            }
        }
    }

    const tableTemplateArray = Object.entries(tableTemplate).map(([key, value]) => {
        return {
            timestamp: key,
            ...value
        }
    }).sort((a, b) => {
        return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    })

    return {columns, content: tableTemplateArray.map(obj => ({...obj, timestamp: formatTime(obj.timestamp)}))};
};

